import React, { Component } from 'react';
import Util from "../../util/Util";
import { BASE_URIS } from "../domain/constants";
class TpicPage extends Component {
  constructor(props) {
    super(props);
    Util.fetchWithRedirect(BASE_URIS.session, 'GET', this.props).catch(error => {});
  }
}
export default TpicPage;